
import React from 'react'
import { IGeneralData, Column } from '@np/np_webcomponentlib'
import { ColumnWithCopyToClipboard } from '../../shared/entityOperations/EntityOperationsCustomFC'

export interface ContragentDataType {
  clientID: string;
  totalAmount: number;
  operationCount: number;
  idBusiness: string;
  merchantName?: string;
  lastOperationDate: string;
}

export interface ProviderBinding {
  idUnique: string;
  clientID: string;
  idBusiness: string;
  providerName: string;
  idProvider?: string;
  dateAdded: string;
}

export interface BindingInfo {
  providerName: string;
  idProvider?: string;
}

export const columnsIdrfcharacteristictype: Column[] = [
  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: any) => (
      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },

  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 6,
    withFilter: 'all',
  },

  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },

  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },
]

export const columnsProviderChoose: Column[] = [
  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 1,
    withFilter: 'all',
  },
]
